const TermsCondition = () => {
	return (
		<>
			<section className="contact py-80">
				<div className="container container-lg">
					<div className="row gy-5">
						<div className="col-lg-12">
							<div className="contact-box border border-gray-100 rounded-16 px-24 py-40">
								<h4 className="text-bold headingsize ">
									Warranty & Other{" "}
									<span className="primecolor">Terms and Conditions</span>
								</h4>

								<ul className="mt-32">
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											We make every effort to provide our clients with exactly
											what they require and share all available information
											about the product.
										</span>
									</li>

									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											“AL SUKOON GEN. TRDG. CO. L.L.C” maintains the website
											<a
												href="https://udemandme.com "
												target="_blank"
												rel="noreferrer"
												className="px-2"
											>
												https://udemandme.com{" "}
											</a>{" "}
											(“Site”).
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											The United Arab Emirates (UAE) is our country of domicile,
											and all legal matters will be governed by local UAE law.
											Any disputes arising in connection with the site shall be
											heard only by a court of competent jurisdiction in the
											UAE.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Visa and MasterCard debit and credit cards in local
											currency will be accepted for payment.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											We do not trade with or provide services to OFAC (Office
											of Foreign Assets Control) sanctioned countries, in
											compliance with UAE law. Customers using the website who
											are minors (under the age of 18) are not permitted to
											register or transact on the site, as per UAE law.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14 mx-5 px-5">
										<span className="text-md text-gray-900 ">
											The cardholder must retain a copy of transaction records
											and Udemandme.com’s policies and rules.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Users are responsible for maintaining the confidentiality
											of their account.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											Return and refund processes will follow the terms outlined
											in our Return/Replacement Policy.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											If your purchase malfunctions during the warranty period
											(as explicitly specified), please contact us at
											info@udemand.me with images and a description of the
											issue. Our team will assist you with repairs or a
											replacement. Please note that the decision to repair or
											replace lies solely with us.
										</span>
									</li>
									<li className="text-gray-400 mb-14 flex-align gap-14">
										<span className="text-md text-gray-900 ">
											We are always available to assist our valued clients.
										</span>
									</li>
								</ul>
							</div>
						</div>
					</div>
				</div>
			</section>
		</>
	);
};
export default TermsCondition;
